import React from 'react'
import { DeviceDataType } from '../device-types'
import { StatusAlertSmall } from '../../../components/Wemolo'

export const getDeviceStatus = (device: DeviceDataType | null): string => {
    if (!device) {
        return ''
    }

    if (device.config_current_timestamp && device.config_target_timestamp) {
        if (device.config_current_timestamp === device.config_target_timestamp) {
            return device.config_force_update ? 'UP-TO-DATE (force update)' : 'UP-TO-DATE'
        } else {
            return 'UPDATING ' + (device.config_force_update ? 'ASAP' : 'SOON')
        }
    }

    return 'UNKNOWN'
}

export const getStatusColor = (status: string) => {
    if (!status) return <>-</>

    let variant: 'green' | 'yellow' | 'red' | 'gray'
    if (status === 'UP-TO-DATE' || status === 'UP-TO-DATE (force update)') {
        variant = 'green'
    } else if (status.startsWith('UPDATING')) {
        variant = 'yellow'
    } else if (status === 'UNKNOWN') {
        variant = 'yellow'
    } else {
        variant = 'red'
    }
    return <StatusAlertSmall variant={variant}>{status}</StatusAlertSmall>
}
